
import { defineComponent, onBeforeMount, reactive } from 'vue'

// @ui-kit
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'
import { settings } from '@/core/realisations/settings.realisation'
import { NotificationItSettingT } from '@/core/types/settings.types'

export default defineComponent({
    components: {
        NewButton,
        NewInput,
        NewSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isChat: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const data_state = reactive({
            settings: {
                is_loading: false,
                is_failed: false,
                list: [] as NotificationItSettingT[],
                pagination: {
                    current_page: 1,
                    total_pages: 1,
                    limit: null as number | null,
                    total_items: null as number | null,
                },
            },
        })
        const state = reactive({
            phoneNumber: null as string | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            senderName: null as string | null,
            invoiceNumber: null as string | null,
            orderNumber: null as string | null,
            typeId: null as number | null,
        })

        const extractNumbers = (str: string) => {
            return str.replace(/\D/g, '')
        }

        const onFiltersChanged = () => {
            if (props.disabled || props.loading) return

            emit('submit', {
                phoneNumber: state.phoneNumber ? extractNumbers(state.phoneNumber) : null,
                createdAtFrom: state.createdAtFrom,
                createdAtTo: state.createdAtTo,
                senderName: state.senderName,
                invoiceNumber: state.invoiceNumber,
                orderNumber: state.orderNumber,
                typeId: state.typeId,
            })
        }

        const onFiltersReset = () => {
            state.phoneNumber = null
            state.createdAtFrom = null
            state.createdAtTo = null
            state.senderName = null
            state.invoiceNumber = null
            state.orderNumber = null
            state.typeId = null

            emit('reset')
        }

        const loadSettings = async () => {
            data_state.settings.pagination.current_page = 1

            try {
                data_state.settings.is_loading = true

                const operators = await settings.getNotificationsItList(1, 999)

                data_state.settings.list = operators.data

                data_state.settings.pagination.total_pages = operators.meta.last_page

                data_state.settings.is_failed = false
            } catch (error) {
                data_state.settings.is_failed = true
                console.error(error)
            } finally {
                data_state.settings.is_loading = false
            }
        }

        onBeforeMount(loadSettings)

        return {
            state,
            onFiltersChanged,
            onFiltersReset,
            data_state,
            loadSettings,
        }
    },
})
